import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  RaisedButton,
  IconButton,
  AppBar,
  Snackbar,
  TextField,
} from 'material-ui';
import { addClient } from '../../actions/Clients';
import ContentBackspace from 'material-ui/svg-icons/content/backspace';

const styles = {
  detail: {
    margin: 12,
  },
};

class AddClient extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  state = {
    message: null,
  };

  static propTypes = {
    addClient: PropTypes.func,
  };

  addClient = ({ clientId }) => {
    this.props
      .addClient({ id: clientId })
      .then((res) => {
        if (!res.error) {
          this.setState({ message: 'Client has been added!' });
          this.goToClient(res.data.id);
        } else {
          this.setState({ message: res.data });
        }
      });
  };

  goToClient = (clientId) => {
    this.context.router.push(`/clients/${clientId}`);
  };

  clearMessage = () => {
    this.setState({ message: null });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const clientId = this.refs.clientId.getValue();
    this.addClient({ clientId });
  };

  closeEdit = () => {
    this.context.router.push('/clients');
  };

  render() {
    const { message } = this.state;

    return (
      <div>
        <div>
          <AppBar
            title="Add Client"
            iconElementLeft={
              <IconButton
                tooltip="Cancel"
                tooltipPosition="top-right"
                onClick={this.closeEdit}
              >
                <ContentBackspace />
              </IconButton>
            }
          />
          <div style={styles.detail}>
            <TextField
              fullWidth
              id="clientId"
              hintText=""
              floatingLabelText="Client ID"
              ref="clientId"
              type="text"
            />

            <RaisedButton
              fullWidth
              label="Add Client"
              onClick={this.handleSubmit}
            />
          </div>
          <Snackbar
            message={message || ''}
            open={!!message}
            autoHideDuration={1500}
            onRequestClose={this.clearMessage}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    addClient: bindActionCreators(addClient, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddClient);
